import { c as _c } from "react/compiler-runtime";
import type { IconProps } from './Icon.types';
import { IconWrapper } from './IconWrapper';
const Duration = t0 => {
  const $ = _c(7);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  let t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <path d="M11.94 6v6L7.7 16.24" strokeLinecap="round" strokeLinejoin="round" />;
    t2 = <path d="M11.84 22.06c-4.87-.05-9.1-3.64-9.79-8.61-.77-5.47 3.04-10.53 8.51-11.3s10.53 3.04 11.29 8.51a9.99 9.99 0 0 1-4.67 9.91" strokeLinecap="round" strokeLinejoin="round" />;
    t3 = <path d="m16.61 16.45.61 4.36c.05.33.35.56.68.51l4.36-.61" strokeLinecap="round" strokeLinejoin="round" />;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
  }
  let t4;
  if ($[5] !== props) {
    t4 = <IconWrapper {...props} variant="outline">{t1}{t2}{t3}</IconWrapper>;
    $[5] = props;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};
export { Duration };